import Vue from 'vue'
import { teacherStore } from 'kuaidong-store'
import { Route } from 'vue-router/types/router'
import VueRouter, { RouteConfig } from 'vue-router'

import RCustom, * as customRouter from './RCustom'
import ROrganization, * as organizationRouter from './ROrganization'

import RLongBreak from './RLongBreak'
import RAuth, * as authRouter from './RAuth'
import RHome, * as homeRouter from './RHome'
import RPlan, * as planRouter from './RPlan'
import RExam, * as examRouter from './RExam'
import RUser, * as userRouter from './RUser'
import RSchool, * as schoolRouter from './RSchool'
import RSystem, * as systemRouter from './RSystem'
import RActivity, * as activityRouter from './RActivity'
import RResource, * as resourceRouter from './RResource'
import RHomework, * as homeworkRouter from './RHomework'
import RTeachSource, * as teachRouter from './RTeachSource'
import RWorkbench, * as workbenchRouter from './RWorkbench'
import RCourseLive, * as courseLiveRouter from './RCourseLive'
import RCompetition, * as competitionRouter from './RCompetition'
import RNoticeCenter, * as noticeCenterRouter from './RNoticeCenter'
import RDigitalSports, * as digitalSportsRouter from './RDigitalSports'
import RProcessEvaluation, * as processEvaluationRouter from './RProcessEvaluation'
import RBroadcastGymnastics, * as broadcastGymnasticsRouter from './RBroadcastGymnastics'
import RExercisePrescription, * as exercisePrescriptionRouter from './RExercisePrescription'
import RIntelligentClassroom, * as intelligentClassroomRouter from './RIntelligentClassroom'
import RDataBoard, * as dashBoardRouter from './RDataBoard'
import RAutumn2022, * as autumn20222022Router from '@/router/RAutumn2022'
import RWinter2023 from './RWinter2023'
import RSpecialSkill, * as specialSkillRouter from '@/router/RSpecialSkill'
import RPEKnowledge, * as peKnowledgeRouter from '@/router/RPEKnowledge'
import RWorkContest, * as workContestRouter from './RWorkContest'

const Layout = () => import('../views/Layout.vue')

Vue.use(VueRouter)

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'layout',
    component: Layout,
    redirect: RWorkbench[0],
    children: [...RWorkbench, ...RHome, ...RNoticeCenter],
  },
  ...RDataBoard,
  ...RAuth,
  ...RPlan,
  ...RDigitalSports,
  ...RIntelligentClassroom,
  ...RWinter2023,
  ...RAutumn2022,
  ...RHomework,
  ...RProcessEvaluation,
  ...RResource,
  ...RSystem,
  ...RCompetition,
  ...RExam,
  ...RExercisePrescription,
  ...RPEKnowledge,
  ...RTeachSource,
  ...RCourseLive,
  ...RBroadcastGymnastics,
  ...RUser,
  ...ROrganization,
  ...RActivity,
  ...RLongBreak,
  ...RSpecialSkill,
  ...RCustom,
  ...RSchool,
  ...RWorkContest,
  // default
  {
    path: '*',
    name: '*',
    redirect: RWorkbench[0],
  },
]

const router = new VueRouter({
  routes,
})

router.beforeEach((to: Route, from: Route, next: any) => {
  //  防止刷新跳转到介绍页
  if (!teacherStore.isSportMeetingSchool && to.fullPath.startsWith('/competition-online-game/online-game-list')) {
    next(/**{ path: '/competition/online-intro' } */)
  } else {
    if (teacherStore.isPaidSchool || teacherStore?.teacher === null) {
      next()
    } else {
      if (to.fullPath.startsWith('/exercise-prescription') && to.name !== 'ep_intro') {
        next({ name: 'ep_intro' })
      } else {
        next()
      }
    }
  }
})

export default router

export const ignoreLoginRoutes: RouteConfig[] = [authRouter.authFormQuickRoute]

export const ignoreLoginInBrowserRoutes: RouteConfig[] = []

export const ignoreAuthRoutes: RouteConfig[] = []

export {
  authRouter,
  homeRouter,
  planRouter,
  examRouter,
  userRouter,
  teachRouter,
  schoolRouter,
  systemRouter,
  customRouter,
  resourceRouter,
  homeworkRouter,
  activityRouter,
  workbenchRouter,
  courseLiveRouter,
  competitionRouter,
  organizationRouter,
  noticeCenterRouter,
  digitalSportsRouter,
  processEvaluationRouter,
  broadcastGymnasticsRouter,
  exercisePrescriptionRouter,
  intelligentClassroomRouter,
  dashBoardRouter,
  autumn20222022Router,
  specialSkillRouter,
  peKnowledgeRouter,
  workContestRouter,
}
